import React from "react";
import PropTypes from "prop-types";
import { FormSpacingContext } from "./form-spacing-context";
const FormSpacingProvider = ({
  marginBottom,
  children
}) => /*#__PURE__*/React.createElement(FormSpacingContext.Provider, {
  value: {
    marginBottom
  }
}, children);
export default FormSpacingProvider;